import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const ElderlyPeopleIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "ElderlyPeopleGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M13.2697 6.34419C12.0718 6.34419 11.0976 5.36995 11.0976 4.17209C11.0976 2.97424 12.0718 2 13.2697 2C14.4675 2 15.4418 2.97424 15.4418 4.17209C15.4418 5.36995 14.4675 6.34419 13.2697 6.34419ZM13.2697 3.00872C12.6284 3.00872 12.1063 3.53081 12.1063 4.17209C12.1063 4.81338 12.6284 5.33547 13.2697 5.33547C13.911 5.33547 14.4331 4.81338 14.4331 4.17209C14.4331 3.53081 13.911 3.00872 13.2697 3.00872Z"
        fill="#696969"
      />
      <path
        d="M14.3198 22C13.9154 22 13.5465 21.8444 13.2697 21.5912C12.9929 21.8444 12.624 22 12.2196 22C11.3626 22 10.6651 21.3026 10.6651 20.4455V15.2581C10.4952 15.3222 10.3115 15.3566 10.1194 15.3566C9.26238 15.3566 8.56494 14.6592 8.56494 13.8022V9.5437C8.56494 8.30841 9.57021 7.30364 10.8055 7.30364H15.7338C16.9691 7.30364 17.9744 8.30841 17.9744 9.5437V13.8022C17.9744 14.6592 17.2769 15.3566 16.4199 15.3566C16.2278 15.3566 16.0441 15.3222 15.8742 15.2581V20.4455C15.8742 21.3026 15.1768 22 14.3198 22ZM13.2697 19.9412C13.5485 19.9412 13.774 20.1668 13.774 20.4455C13.774 20.746 14.0188 20.9913 14.3198 20.9913C14.6207 20.9913 14.8655 20.746 14.8655 20.4455V13.8022C14.8655 13.5234 15.0911 13.2978 15.3699 13.2978C15.6487 13.2978 15.8742 13.5234 15.8742 13.8022C15.8742 14.1026 16.119 14.3479 16.42 14.3479C16.7209 14.3479 16.9657 14.1026 16.9657 13.8022V9.5437C16.9657 8.86498 16.4131 8.31236 15.7339 8.31236H10.8055C10.1263 8.31236 9.5737 8.86498 9.5737 9.5437V13.8022C9.5737 14.1026 9.8185 14.3479 10.1194 14.3479C10.4204 14.3479 10.6652 14.1026 10.6652 13.8022C10.6652 13.5234 10.8908 13.2978 11.1695 13.2978C11.4483 13.2978 11.6739 13.5234 11.6739 13.8022V20.4455C11.6739 20.746 11.9187 20.9913 12.2196 20.9913C12.5206 20.9913 12.7654 20.746 12.7654 20.4455C12.7654 20.1668 12.9909 19.9412 13.2697 19.9412Z"
        fill="#696969"
      />
      <path
        d="M13.2697 20.9499C12.9909 20.9499 12.7654 20.7243 12.7654 20.4455L12.7653 13.9086C12.7653 13.6298 12.9909 13.4042 13.2697 13.4042C13.5485 13.4042 13.774 13.6298 13.774 13.9086V20.4455C13.774 20.7243 13.5485 20.9499 13.2697 20.9499Z"
        fill="#696969"
      />
      <path
        d="M15.3699 14.3066C15.0911 14.3066 14.8655 14.081 14.8655 13.8022L14.8655 10.6332C14.8655 10.3544 15.0911 10.1288 15.3699 10.1288C15.6486 10.1288 15.8742 10.3544 15.8742 10.6332L15.8742 13.8022C15.8742 14.081 15.6486 14.3066 15.3699 14.3066Z"
        fill="#696969"
      />
      <path
        d="M11.1542 14.3066C10.8755 14.3066 10.6499 14.081 10.6499 13.8022V10.6332C10.6499 10.3544 10.8755 10.1288 11.1542 10.1288C11.433 10.1288 11.6586 10.3544 11.6586 10.6332V13.8022C11.6586 14.081 11.433 14.3066 11.1542 14.3066Z"
        fill="#696969"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.5 15.5C7.5 14.6716 8.17157 14 9 14C9.27614 14 9.5 14.2239 9.5 14.5C9.5 14.7761 9.27614 15 9 15C8.72386 15 8.5 15.2239 8.5 15.5V19.5H9C9.82843 19.5 10.5 20.1716 10.5 21V21.5C10.5 21.7761 10.2761 22 10 22C9.72386 22 9.5 21.7761 9.5 21.5V21C9.5 20.7239 9.27614 20.5 9 20.5H8.5V21.5C8.5 21.7761 8.27614 22 8 22C7.72386 22 7.5 21.7761 7.5 21.5V20.5H7C6.72386 20.5 6.5 20.7239 6.5 21V21.5C6.5 21.7761 6.27614 22 6 22C5.72386 22 5.5 21.7761 5.5 21.5V21C5.5 20.1716 6.17157 19.5 7 19.5H7.5V15.5Z"
        fill="#696969"
      />
    </svg>
  );
};

export default ElderlyPeopleIcon;
